export default {
  order: 5,
  layerGroupId: 'GROUP_LC',
  dataLayer: {
    id: 'LAND_COVER',
    order: 5,
    type: 'remoteDataLayer',
    uuid: 'b8d3f175-0565-443f-839a-49eb890a4b3d',
    groupId: 'GROUP_LC',
  },
  layer: {
    label: {
      ka: 'მიწის საფარი',
      zh: '土地覆盖',
      id: 'Tutupan Lahan',
      pt: 'Cobertura da terra',
      es: 'Cobertura de la tierra',
      fr: 'Couverture terrestre',
      en: 'Land Cover',
    },
    sublabel: {
      ka: '(2015, გლობალური, globecover – ESA/ UCLouvain)  ',
      zh: '（2015 年，全球，globecover – ESA/ UCLouvain）',
      id: '(2015, global, globecover – ESA/UCLouvain)',
      pt: '(2015, global, globecover – ESA/ UCLouvain)',
      es: '(2015, global, globecover; ESA/UCLouvain)',
      fr: '(2015, mondiale, globecover – ESA/ UCLouvain)',
      en: '(2015, global, globecover – ESA/ UCLouvain)',
    },
    technicalName: 'global_landcover',
    url: 'https://s3.amazonaws.com/wri-tiles/global-landcover-2015/{level}/{col}/{row}.png',
    type: 'webtiled',
    id: 'LAND_COVER',
    metadata: {
      metadata: null,
      legendConfig: {
        type: 'basic',
        source: '(GlobCover, 2015)',
        name: {
          ka: 'მიწის საფარი',
          zh: '土地覆盖',
          id: 'Tutupan Lahan',
          pt: 'Cobertura da terra',
          es: 'Cobertura de la tierra',
          fr: 'Couverture des sols',
          en: 'Land Cover',
        },
        items: [
          {
            color: '#8b6726',
            name: {
              en: 'Irrigated croplands',
              fr: 'Terres cultivées irriguées',
              es: 'Tierras de cultivo irrigadas',
              pt: 'Terras agrícolas irrigadas',
              id: 'Lahan pertanian irigasi',
              zh: '灌溉农田',
              ka: 'მორწყვადი ს/ს კულტურები',
            },
          },
          {
            color: '#d3b258',
            name: {
              en: 'Rainfed croplands',
              fr: 'Terres cultivées pluviales',
              es: 'Tierras de cultivo sin riego',
              pt: 'Terras agrícolas dependente de chuvas',
              id: 'Lahan pertanian tadah hujan',
              zh: '旱作农田',
              ka: 'წვიმით მორწყვადი კულტურები',
            },
          },
          {
            color: '#d8ce88',
            name: {
              en: 'Cropland forest mosaic',
              fr: 'Mosaïque forêt/terres cultivées',
              es: 'Mosaico de tierras agroforestales',
              pt: 'Mosaico de floresta e terra agrícola',
              id: 'Campuran lahan pertanian dan hutan',
              zh: '农田森林镶嵌体',
              ka: 'ს/ს კულტურების და ტყის მოზაიკა',
            },
          },
          {
            color: '#3d7e5a',
            name: {
              en: 'Broadleaved evergreen or semi-deciduous forest',
              fr: 'Forêt de feuillus à feuillage persistant ou semi-décidue',
              es: 'Bosque perenne o semicaducifolio de hoja ancha',
              pt: 'Floresta latifoliada (folha larga) perenifólia ou semidecidual',
              id: 'Hutan vegetasi berdaun lebar sepanjang tahun atau hutan semi gugur berdaun lebar ',
              zh: '常绿阔叶或半落叶林',
              ka: 'ფართოფოთლოვანი მარადმწვანე ან ნახევრად  ფოთოლმცვენი ტყე',
            },
          },
          {
            color: '#cc8223',
            name: {
              en: 'Broadleaved deciduous forest',
              fr: 'Forêt de feuillus à feuilles caduques',
              es: 'Bosque caducifolio de hoja ancha',
              pt: 'Floresta latifoliada (folha larga) decidual',
              id: 'Hutan gugur berdaun lebar',
              zh: '落叶阔叶林',
              ka: 'ფართოფოთლოვანი ფოთოლმცვენი ტყე',
            },
          },
          {
            color: '#86b689',
            name: {
              en: 'Needleleaved evergreen or deciduous forest',
              fr: 'Forêt de conifères persistants ou décidue',
              es: 'Bosques de coníferas o caducifolios',
              pt: 'Floresta aciculifoliada (folha fina) perenifólia ou decidual',
              id: 'Hutan vegetasi berdaun jarum sepanjang tahun atau hutan gugur berdaun jarum',
              zh: '常绿针叶或落叶林',
              ka: 'წიწვოვანი მარადმწვანე ან ფოთოლმცვენი ტყე',
            },
          },
          {
            color: '#a2912b',
            name: {
              en: 'Mixed broadleaved and needleleaved forest',
              fr: 'Forêt mixte de feuillus et de conifères',
              es: 'Bosque mixto de hoja ancha y coníferas',
              pt: 'Floresta mista latifoliada (folha larga) e aciculifoliada (folha fina)',
              id: 'Hutan campuran berdaun lebar dan berdaun jarum',
              zh: '针阔叶混交林',
              ka: 'შერეული ფართოფოთლოვანი და წიწვოვანი ტყე',
            },
          },
          {
            color: '#c9be15',
            name: {
              en: 'Mosaic of forest, shrubland and grassland',
              fr: "Mosaïque de forêts, d'arbustaies et de prairies",
              es: 'Mosaico de bosque, matorral y pastizal',
              pt: 'Mosaico de floresta, vegetação arbustiva e campo',
              id: 'Campuran tutupan hutan, semak belukar dan padang rumput',
              zh: '森林、灌木和草地镶嵌体',
              ka: 'ტყის, ბუჩქნარის და მინდორის მოზაიკა',
            },
          },
          {
            color: '#7b824b',
            name: {
              en: 'Shrubland',
              fr: 'Arbustaies',
              es: 'Matorral',
              pt: 'Vegetação arbustiva',
              id: 'Semak belukar',
              zh: '灌木',
              ka: 'ბუჩქნარი',
            },
          },
          {
            color: '#a5ae63',
            name: {
              en: 'Grassland',
              fr: 'Prairies',
              es: 'Pastizal',
              pt: 'Campo',
              id: 'Padang Rumput',
              zh: '草地',
              ka: 'მინდორი',
            },
          },
          {
            color: '#d4df82',
            name: {
              en: 'Sparse vegetation',
              fr: 'Végétation clairsemée',
              es: 'Vegetación escasa',
              pt: 'Vegetação esparsa',
              id: 'Vegetasi jarang',
              zh: '稀疏植被',
              ka: 'მეჩხერი მცენარეულობა',
            },
          },
          {
            color: '#9abfda',
            name: {
              en: 'Flooded broadleaved forest',
              fr: 'Forêt de feuillus inondée',
              es: 'Bosque de hoja ancha inundado',
              pt: 'Floresta latifoliada (folha larga) inundada',
              id: 'Hutan berdaun lebar terendam',
              zh: '被淹没的阔叶林',
              ka: 'დატბორილი ფართოფოთლოვანი ტყე ',
            },
          },
          {
            color: '#3f6495',
            name: {
              en: 'Flooded vegetation',
              fr: 'Végétation inondée',
              es: 'Vegetación inundada',
              pt: 'Vegetação inundada',
              id: 'Vegetasi terendam',
              zh: '被淹没的植被',
              ka: 'დატბორილი მცენარეულობა',
            },
          },
          {
            color: '#e70061',
            name: {
              en: 'Artificial areas',
              fr: 'Zones artificielles',
              es: 'Áreas artificiales',
              pt: 'Áreas artificiais',
              id: 'Kawasan buatan',
              zh: '人造区域',
              ka: 'სახეცვლილი (ხელოვნური) ადგილები',
            },
          },
          {
            color: '#f6eedb',
            name: {
              en: 'Bare areas',
              fr: 'Zones nues',
              es: 'Áreas sin vegetación',
              pt: 'Solo expostos',
              id: 'Kawasan terbuka',
              zh: '裸地',
              ka: 'მოშიშვლებული ადგილები',
            },
          },
          {
            color: '#e1ddce',
            name: {
              en: 'Permanent snow and ice',
              fr: 'Neige et glace permanentes',
              es: 'Hielo y nieve permanentes',
              pt: 'Neve e gelo permanentes',
              id: 'Salju dan es permanen',
              zh: '长年冰雪',
              ka: 'მუდმივი თოვლი და ყინული',
            },
          },
        ],
      },
      interactionConfig: {},
    },
  },
  isMetadataError: false,
  isError: false,
};
